// src/pages/logistica/MpDesglose.jsx
import { useEffect, useState } from 'react';
import api from '../../services/api';

const GRUPOS = ['Desglose 1', 'Desglose 2', 'ME'];

export default function MpDesglose() {
  const [filas, setFilas] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [guardandoClave, setGuardandoClave] = useState(null);
  const [sincronizando, setSincronizando] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  async function cargar() {
    try {
      setCargando(true);
      const res = await api.get('/api/logistica/mp-desglose');
      setFilas(res.data.data);
    } catch (err) {
      console.error(err);
    } finally {
      setCargando(false);
    }
  }

  useEffect(() => { cargar(); }, []);

  async function handleSincronizar() {
    try {
      setSincronizando(true);
      setMensaje(null);
      const res = await api.post('/api/logistica/mp-desglose/sync');
      await cargar();
      setMensaje({ tipo: 'ok', texto: `✓ Sincronizado: ${res.data.procesados}/${res.data.total} lotes desde NetSuite.` });
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: 'No se pudo sincronizar con NetSuite.' });
    } finally {
      setSincronizando(false);
    }
  }

  function handleCambiar(articuloClave, grupo) {
    setFilas((prev) => prev.map((f) => (f.articulo_clave === articuloClave ? { ...f, grupo } : f)));
  }

  async function handleGuardar(articuloClave) {
    const fila = filas.find((f) => f.articulo_clave === articuloClave);
    try {
      setGuardandoClave(articuloClave);
      setMensaje(null);
      await api.put(`/api/logistica/mp-desglose/${encodeURIComponent(articuloClave)}`, { grupo: fila.grupo });
      setMensaje({ tipo: 'ok', texto: `✓ ${fila.articulo} → ${fila.grupo}` });
      cargar(); // recarga para que los ya clasificados bajen de la lista de pendientes
    } catch (err) {
      console.error(err);
      setMensaje({ tipo: 'error', texto: err.response?.data?.error || `No se pudo guardar ${fila.articulo}.` });
    } finally {
      setGuardandoClave(null);
    }
  }

  if (cargando) return <div style={styles.contenedor}>Cargando...</div>;

  const pendientes = filas.filter((f) => !f.grupo).length;

  return (
    <div style={styles.contenedor}>
      <div style={styles.encabezado}>
        <div>
          <h1 style={styles.titulo}>Grupo de Desglose — MP y Empaque</h1>
          <p style={styles.subtitulo}>
            Define en qué semana se cuenta cada artículo (Desglose 1, Desglose 2 o ME) para el KPI de Exactitud de Inventario.
            {pendientes > 0 && (
              <span style={styles.pendientesAviso}> {pendientes} artículo{pendientes === 1 ? '' : 's'} sin clasificar.</span>
            )}
          </p>
        </div>
        <button onClick={handleSincronizar} disabled={sincronizando} style={styles.botonSync}>
          {sincronizando ? 'Sincronizando...' : '↻ Sincronizar con NetSuite'}
        </button>
      </div>

      {mensaje && <div style={{ ...styles.mensaje, color: mensaje.tipo === 'ok' ? '#3E7C5A' : '#B23A48' }}>{mensaje.texto}</div>}

      <div style={styles.tarjeta}>
        {filas.map((f) => {
          const faltaClasificar = !f.grupo;
          return (
            <div key={f.articulo_clave} style={{ ...styles.fila, ...(faltaClasificar ? styles.filaPendiente : {}) }}>
              <div style={styles.articuloNombre}>{f.articulo}</div>
              <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                <select
                  value={f.grupo || ''}
                  onChange={(e) => handleCambiar(f.articulo_clave, e.target.value)}
                  style={{ ...styles.select, ...(faltaClasificar ? styles.selectPendiente : {}) }}
                >
                  <option value="" disabled>Elegir grupo…</option>
                  {GRUPOS.map((g) => (
                    <option key={g} value={g}>{g}</option>
                  ))}
                </select>
                <button
                  onClick={() => handleGuardar(f.articulo_clave)}
                  disabled={guardandoClave === f.articulo_clave || !f.grupo}
                  style={styles.botonGuardar}
                >
                  {guardandoClave === f.articulo_clave ? '...' : 'Guardar'}
                </button>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

const styles = {
  contenedor: { fontFamily: 'Inter, sans-serif', padding: '24px', color: '#3A2E42', maxWidth: '640px' },
  encabezado: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '14px', marginBottom: '4px' },
  botonSync: { flexShrink: 0, padding: '9px 14px', fontSize: '12px', fontWeight: 600, color: '#fff', background: '#6A2C75', border: 'none', borderRadius: '8px', cursor: 'pointer', whiteSpace: 'nowrap' },
  titulo: { fontFamily: 'Playfair Display, serif', color: '#2A1830', marginBottom: '4px' },
  subtitulo: { fontSize: '12px', color: '#8A7690', marginBottom: '18px' },
  pendientesAviso: { color: '#B23A48', fontWeight: 600 },
  mensaje: { fontSize: '13px', marginBottom: '14px', fontWeight: 600 },
  tarjeta: { background: '#fff', border: '1px solid #E6DDD2', borderRadius: '12px', padding: '18px', boxShadow: '0 2px 14px rgba(74,30,92,0.07)', display: 'flex', flexDirection: 'column', gap: '14px' },
  fila: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '14px', paddingBottom: '14px', borderBottom: '1px solid #F0E9E0' },
  filaPendiente: { background: '#FDF3F1', margin: '0 -18px', padding: '10px 18px', borderRadius: '8px' },
  articuloNombre: { fontSize: '14px', fontWeight: 700, color: '#2A1830' },
  select: { padding: '7px 10px', fontSize: '13px', border: '1px solid #D6A644', borderRadius: '6px', fontFamily: 'Inter, sans-serif', background: '#FFFDF7', minWidth: '130px' },
  selectPendiente: { borderColor: '#B23A48' },
  botonGuardar: { padding: '6px 14px', fontSize: '12px', fontWeight: 600, color: '#6E4F80', background: '#EFE9F3', border: '1px solid #A98BB8', borderRadius: '6px', cursor: 'pointer' },
};